import {
    SimpleForm,
    TextInput,
    NumberInput,
    FormDataConsumer,
} from 'react-admin';
import {
    EditNode,
    EditNodeToolbar,
    TreeWithDetails,
} from '@react-admin/ra-tree';
// import { useClientContext } from 'contexts/client';
import { Stack, Box } from '@mui/material';



const DistributorEdit = () => { 
    // const { state: client } = useClientContext();

    return (
        <EditNode>
            <SimpleForm toolbar={<EditNodeToolbar />}>
                <Stack sx={{width: '100%'}}>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <NumberInput source="id" label="ID" sx={{maxWidth: 70}} disabled />
                        <TextInput source="name" disabled sx={{ flex: 3 }} />
                    </Box>                    
                    <FormDataConsumer>
                        {({ formData }) => (
                            <a href={`${window.location.href}/show`}>Show Details</a>
                        )}
                    </FormDataConsumer>

                </Stack>                
            </SimpleForm>
        </EditNode>
    );
}

export const DistributorList = () => (
    <TreeWithDetails
        create={null}
        addRootButton={false}
        titleField='name' 
        linkTo="edit"
        allowMultipleRoots
        edit={DistributorEdit}
        nodeActions={<div></div>}
    />
);

export default DistributorList;
